import * as ngCommon from '@angular/common'
import * as ngCore from '@angular/core'
import * as ec from '@attain-apps/fe/web/main/lib/entity-collection'

import * as input from '../../../input'
import { AtnDsTableStore } from '../../store'
import * as cell from '../cell'

import * as iconsRenderer from './icons-renderer'

const TABLE_PADDING_WIDTH = 40 // 2 * 20px

@ngCore.Component({
  imports: [
    ngCommon.JsonPipe,
    ngCommon.NgStyle,
    cell.renderer.Component,
    iconsRenderer.Component,
    input.checkbox.Component,
  ],
  selector: 'table-rows',
  standalone: true,
  styleUrl: './component.scss',
  templateUrl: './component.html',
})
export class Component<
  TTypeParams extends
    ec.models.TypeParams.Constraint = ec.models.TypeParams.Constraint,
> {
  /** @see {@link AtnDsTableStore} */
  public readonly store =
    ngCore.inject<AtnDsTableStore<TTypeParams>>(AtnDsTableStore)

  /**
   * Collection of cells, used for calculating width of the cell with the
   * maximum width
   */
  public measuredElementsSg =
    ngCore.viewChildren<ngCore.ElementRef>('measuredElement')

  /**
   * Computes the left offset position of the icons column relative to the table.
   *
   * This value is determined based on the table's horizontal scroll position (if horizontal scroll exists),
   * the table's width, and the width of the icons column. It ensures that the icons
   * remain correctly positioned as the table scrolls horizontally.
   *
   * @returns {number} The calculated left position of the icons column.
   */
  public readonly iconsElOffsetLeftPositionSg = ngCore.computed(
    (
      horizontalScrollLeftOffsetPosition = this.store.horizontalScrollLeftOffsetPositionSg(),
      tableWidth = this.store.tableWidthSg(),
      iconsColumWidth = this.store.iconsMaxWidthSg(),
    ) => {
      const tableRightPosition =
        horizontalScrollLeftOffsetPosition + tableWidth - TABLE_PADDING_WIDTH
      return tableRightPosition - iconsColumWidth
    },
  )

  public constructor() {
    // Calculating width of the widest content in each column
    ngCore.effect(() => {
      for (const measuredElement of this.measuredElementsSg()) {
        if (measuredElement.nativeElement instanceof HTMLDivElement) {
          const { id, scrollWidth } = measuredElement.nativeElement

          this.store.updateMaxColumnWidth(id, scrollWidth)
        }
      }
    })
  }
}
